import { render } from "./SingleFeedback.vue?vue&type=template&id=e9eb46fc&scoped=true"
import script from "./SingleFeedback.vue?vue&type=script&lang=js"
export * from "./SingleFeedback.vue?vue&type=script&lang=js"

import "./SingleFeedback.vue?vue&type=style&index=0&id=e9eb46fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9eb46fc"]])

export default __exports__